import { bl_pos_terminal_drawer_hdr_RowClass } from '../../../dbschema/bl_pos_terminal_drawer_hdr.model';
import {BaseContainerModel} from '../../base-container.model';


export class PosTerminalDrawerHdrContainerModel extends BaseContainerModel {
  bl_pos_terminal_drawer_hdr: bl_pos_terminal_drawer_hdr_RowClass = new bl_pos_terminal_drawer_hdr_RowClass();
}
